export default "6cba3a47c89b6a81.png"